'use client'
import { useLang } from '../../context/LangContext'
import { t, productVPS } from '../../lib/translations'
import ProductLanding from '../../components/ProductLanding'
import Icon from '../../components/Icon'
import { vpsPlans } from '../../data/plans'

const featureIcons = ['server', 'lightning', 'transfer', 'globe', 'shield-check', 'chart-bar', 'code', 'support'] as const

export default function VPSServerPage() {
  const lang = useLang()
  const features = productVPS.features.map((f, i) => ({
    title: t(lang, f.title),
    description: t(lang, f.description),
    icon: <Icon name={featureIcons[i]} className="w-6 h-6" strokeWidth={1.5} />,
  }))
  const benefits = productVPS.benefits.map((b) => ({ title: t(lang, b.title), desc: t(lang, b.desc) }))

  return (
    <ProductLanding
      id="vps"
      title={t(lang, productVPS.title)}
      subtitle={t(lang, productVPS.subtitle)}
      description={t(lang, productVPS.description)}
      heroBg="bg-gradient-to-b from-[#4f46e5]/5 via-transparent to-transparent"
      heroGlow="bg-[#6366f1]/10"
      features={features}
      benefits={benefits}
      plans={vpsPlans}
    />
  )
}
